export default __webpack_public_path__ + "45598049ac0ef272ca9fda0e799df4f5.png";